var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgTeammates = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  width: "1em",
  height: "1em",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.95 24.22c.2 3.51 2.09 6.85 5.48 8.15 3.44 1.32 7.37.21 9.62-2.71 2.29-2.96 2.55-7.39.74-10.65-1.76-3.17-5.39-5-8.99-4.25-4.18.87-6.72 4.63-6.88 8.74-.01.11-.01.2-.01.26 0 .1 0 .27.04.45ZM40.76 48.78c.22-.32.29-.95.2-1.47-.08-3.07-.68-6.29-2.55-8.8-1.56-2.1-3.91-3.34-6.47-3.73-1.88-.29-3.96-.24-5.86-.12-2.57.17-5.03 1.13-6.83 2.99-2.57 2.67-3.29 6.57-3.33 10.14 0 .3.07 1.2.53 1.2h24c.08 0 .15-.04.21-.09.02-.02.04-.03.06-.05.02-.02.03-.05.05-.08Z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.06 29.67a8.288 8.288 0 0 1-4.17 2.87c-1.04.32-1.75-1.01-.93-1.73.39-.34.75-.73 1.08-1.15 2.29-2.97 2.55-7.39.74-10.65a8.611 8.611 0 0 0-4.64-3.94c-.2-.07-.16-.35.05-.39 3.47-.54 6.92 1.27 8.62 4.33 1.8 3.26 1.54 7.68-.74 10.65ZM47.76 48.78s-.03.05-.05.08c-.01.02-.03.03-.06.05-.05.05-.12.09-.2.09h-2.84c-.52 0-.95-.4-.99-.92-.16-2.17-.73-7.58-2.21-9.57-1.56-2.1-4.18-3.99-2.46-3.73 2.56.39 4.91 1.63 6.47 3.73 1.87 2.51 2.46 5.73 2.55 8.8.09.52.02 1.15-.2 1.47Z"
}))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgTeammates);
export default ForwardRef;